import { Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import { Radio } from "antd";
import { providerStatus } from "../../../../data/data";
import Inputs from "../../../../biblio/Inputs/Inputs";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import { convertFileToBase64 } from "../../../../components/utils/utils";

interface PersonOption {
  id: number;
  name: string;
}

interface MainProviderInfoProps {
  identificationTypes: any;
  nationality: any;
  maritalStatus: any;
  maleOrphans: any;
  femaleOrphans: any;
  orphansBeneficiaryInfo: any;
  guardianRelationships: any;
  banks: any;
  form: any;
  formBank: any;
}

const MainProviderInfo = ({
  identificationTypes,
  nationality,
  maritalStatus,
  femaleOrphans,
  maleOrphans,
  orphansBeneficiaryInfo,
  guardianRelationships,
  banks,
  form,
  formBank,
}: MainProviderInfoProps) => {
  const [value, setValue] = useState<string>("");
  const [options, setOptions] = useState<PersonOption[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [disabled, setDisabled] = useState<boolean>(false);
  const [fileLists, setFileLists] = useState<{ [key: string]: any[] }>({});
  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[], fieldName: string) => {
    const file = fileList[0]?.originFileObj;
    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };
        form.setFieldsValue({
          [fieldName]: [imageData],
        });
        setFileLists((prevState) => ({ ...prevState, [fieldName]: fileList }));
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    } else {
      setFileLists((prevState) => ({ ...prevState, [fieldName]: [] }));
    }
  };

  useEffect(() => {
    setSelectedOption(form.getFieldValue("breadwinner")?.value ?? "");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (e: any) => {
    const selectedValue = e.target.value;
    setValue(selectedValue);
    resetFields(selectedValue, selectedOption);

    if (selectedValue === "son") {
      setOptions(maleOrphans);
    } else if (selectedValue === "daughter") {
      setOptions(femaleOrphans);
    } else if (selectedValue === "mother") {
      onMotherSelect();
      setOptions([]);
    } else {
      setOptions([]);
    }
  };

  const onMotherSelect = () => {
    if (!orphansBeneficiaryInfo) {
      console.error("orphansBeneficiaryInfo is undefined or not populated.");
      return;
    }

    form.setFieldsValue({
      ...form.getFieldsValue(),
      guardian_identification_type_id: {
        key: identificationTypes.data.filter(
          (el: any) =>
            // eslint-disable-next-line eqeqeq
            el.name == orphansBeneficiaryInfo.mother_identification_type_id
        )[0].id,
        value: identificationTypes.data.filter(
          (el: any) =>
            // eslint-disable-next-line eqeqeq
            el.name == orphansBeneficiaryInfo.mother_identification_type_id
        )[0].id,
        label: orphansBeneficiaryInfo.mother_identification_type_id,
      },
      guardian_name: orphansBeneficiaryInfo.mother_name,
      guardian_identification:
        orphansBeneficiaryInfo.mother_identification_number,
      guardian_email: orphansBeneficiaryInfo.mother_email
        ? orphansBeneficiaryInfo.mother_email
        : "",
      guardian_nationality_id: {
        key: nationality.data.filter(
          (el: any) => el.name === orphansBeneficiaryInfo.mother_country_id
        )[0].id,
        value: nationality.data.filter(
          (el: any) => el.name === orphansBeneficiaryInfo.mother_country_id
        )[0].id,
        label: orphansBeneficiaryInfo.mother_country_id,
      },
      guardian_phone:
        // eslint-disable-next-line eqeqeq
        orphansBeneficiaryInfo.mother_phone != false
          ? orphansBeneficiaryInfo.mother_phone
          : "",
      guardian_marital_status_id: {
        key: maritalStatus.data.filter(
          // eslint-disable-next-line eqeqeq
          (el: any) => el.name == orphansBeneficiaryInfo.marital_status_id
        )[0].id,
        value: maritalStatus.data.filter(
          // eslint-disable-next-line eqeqeq
          (el: any) => el.name == orphansBeneficiaryInfo.marital_status_id
        )[0].id,
        label: orphansBeneficiaryInfo.marital_status_id ?? "",
      },
    });
    setDisabled(true);
  };

  const onChangeOrphan = (e: any) => {
    const choosen =
      form.getFieldValue("breadwinner_type") === "son"
        // eslint-disable-next-line eqeqeq
        ? maleOrphans.filter((el: any) => el.id == e.key)[0]
        // eslint-disable-next-line eqeqeq
        : femaleOrphans.filter((el: any) => el.id == e.key)[0];

    form.setFieldsValue({
      ...form.getFieldsValue(),
      guardian_identification_type_id: {
        key: identificationTypes.data.filter(
          // eslint-disable-next-line eqeqeq
          (el: any) => el.name == choosen.identification_type_id
        )[0]?.id,
        value: identificationTypes.data.filter(
          // eslint-disable-next-line eqeqeq
          (el: any) => el.name == choosen.identification_type_id
        )[0]?.id,
        label: choosen.identification_type_id,
      },
      guardian_name: choosen.name,
      guardian_identification: choosen.identification_number,
      // eslint-disable-next-line eqeqeq
      guardian_email: choosen.email != false ? choosen.email : "",
      guardian_nationality_id: {
        key: nationality.data.filter(
          (el: any) => el.name === choosen.nationality_id
        )[0]?.id,
        value: nationality.data.filter(
          (el: any) => el.name === choosen.nationality_id
        )[0]?.id,
        label: choosen.nationality_id,
      },
      // eslint-disable-next-line eqeqeq
      guardian_phone: choosen.mobile != false ? choosen.mobile : "",
      guardian_marital_status_id: {
        key: maritalStatus.data.filter(
          // eslint-disable-next-line eqeqeq
          (el: any) => el.name == choosen.marital_status_id
        )[0]?.id,
        value: maritalStatus.data.filter(
          // eslint-disable-next-line eqeqeq
          (el: any) => el.name == choosen.marital_status_id
        )[0]?.id,
        label: choosen.marital_status_id ?? "",
      },
      guardian_bank_id: {
        key: banks.filter((el: any) => el.name === choosen.bank_id)[0]?.id,
        value: banks.filter((el: any) => el.name === choosen.bank_id)[0]?.id,
        label: choosen.bank_id,
      },
      guardian_account_owner: choosen.account_owner,
      guardian_account_number: choosen.account_number,
    });

    // eslint-disable-next-line eqeqeq
    if (choosen.bank_id && choosen.bank_id != "") {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };

  const resetFields = (selected: any, inOut: any) => {
    form.setFieldsValue({
      ...form.getFieldsValue(),
      guardian_identification_type_id: "",
      guardian_name: "",
      guardian_identification: "",
      guardian_email: "",
      guardian_nationality_id: "",
      guardian_phone: "",
      guardian_marital_status_id: "",
      son_id: "",
      daughter_id: "",
      guardian_actual_profession: "",
      guardian_address: "",
      legal_guardian_image_ids: setFileLists({}),
      legal_agency_image_ids: setFileLists({}),
      guardian_account_number:
        selected === "mother" && inOut === "within_family"
          ? formBank.getFieldValue("account_number")
          : "",
      guardian_bank_id:
        selected === "mother" && inOut === "within_family"
          ? {
              key: banks.filter(
                (el: any) =>
                  el.name === formBank.getFieldValue("bank_id")?.value
              )[0]?.id,
              value: banks.filter(
                (el: any) =>
                  el.name === formBank.getFieldValue("bank_id")?.value
              )[0]?.id,
              label: formBank.getFieldValue("bank_id")?.value,
            }
          : "",
      guardian_account_owner:
        selected === "mother" && inOut === "within_family"
          ? formBank.getFieldValue("account_owner")
          : "",
    });
    setDisabled(false);
  };

  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>العائل الرئيسي</span>
      </div>
      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="breadwinner"
            label="عائل الأسرة"
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
            rules={[{ required: true }]}
          >
            <Selects
              options={providerStatus}
              onChange={(item: any) => {
                setSelectedOption(item.value);
                resetFields(value, item.value);
                if (item.value === "within_family" && value === "mother") {
                  onMotherSelect();
                }
              }}
            />
          </Form.Item>
        </Col>
        {selectedOption === "within_family" && (
          <>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="breadwinner_type"
                className="takaful--label-inputs"
                label=" "
                labelCol={{ className: "takaful--label-style" }}
              >
                <Radio.Group onChange={onChange} value={value}>
                  {!orphansBeneficiaryInfo.is_deceased && (
                    <Radio
                      className="takaful--beneficiary-radio"
                      value={"mother"}
                    >
                      الأم
                    </Radio>
                  )}
                  <Radio className="takaful--beneficiary-radio" value={"son"}>
                    الابن
                  </Radio>
                  <Radio
                    className="takaful--beneficiary-radio"
                    value={"daughter"}
                  >
                    الابنة
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {value !== "mother" && value !== "" && (
              <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                <Form.Item
                  label="الابن(ة)"
                  name={`${value === "son" ? "son_id" : "daughter_id"}`}
                  className="takaful--label-inputs"
                  labelCol={{ className: "takaful--label-style" }}
                >
                  <Selects
                    options={options}
                    onChange={(e) => onChangeOrphan(e)}
                  />
                </Form.Item>
              </Col>
            )}
          </>
        )}
        {selectedOption === "outside_family" && (
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              label="صلة القرابة"
              name="relative_relation_id"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={guardianRelationships} />
            </Form.Item>
          </Col>
        )}
      </Row>

      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_name"
            label="إسم الوصي"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs type="text" disabled={selectedOption === "within_family"} />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_identification_type_id"
            label="نوع الهوية"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              disabled={selectedOption === "within_family"}
              options={identificationTypes?.data}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_identification"
            label="الهوية"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
              {
                len: 10,
                message: "يجب أن يتكون رقم الهوية من 10 ارقام",
              },
            ]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="tel"
              maxLength={10}
              disabled={selectedOption === "within_family"}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_email"
            label="البريد الإلكتروني"
            rules={[
              {
                type: "email",
                message:
                  "يجب أن يحتوي البريد الإلكتروني على الرمز (@) ويتضمن اسم نطاق (.com، .fr).",
              },
            ]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="email"
              disabled={
                selectedOption === "within_family" &&
                (value === "mother"
                  ? orphansBeneficiaryInfo?.mother_email
                  : value === "son"
                  ? maleOrphans[0]?.email
                  : femaleOrphans[0]?.email)
              }
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_nationality_id"
            label="الجنسية"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={nationality?.data}
              disabled={selectedOption === "within_family"}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_actual_profession"
            label="العمل الحالي"
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs type="text" />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_address"
            label="العنوان"
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs type="text" />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_phone"
            label="الجوال"
            rules={[
              {
                len: 10,
                message: "يجب أن يحتوي رقم الجوال على 10 ارقام",
              },
            ]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs
              type="tel"
              maxLength={10}
              disabled={
                selectedOption === "within_family" &&
                (value === "mother"
                  ? orphansBeneficiaryInfo?.mother_phone
                  : value === "son"
                  ? maleOrphans[0]?.mobile
                  : femaleOrphans[0]?.mobile)
              }
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_marital_status_id"
            label="الحالة الإجتماعية"
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={maritalStatus?.data}
              disabled={selectedOption === "within_family"}
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="legal_agency_image_ids"
            label="صورة الوكالة الشرعية"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <UploadInput
              accept="image/*"
              text="صورة الوكالة الشرعية"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={(fileList) =>
                handleFileChange(fileList, "legal_agency_image_ids")
              }
              list={fileLists["legal_agency_image_ids"] || []}
            />
          </Form.Item>
        </Col>
        {selectedOption === "outside_family" && (
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="legal_guardian_image_ids"
              label="صورة هوية الوكيل الشرعي"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <UploadInput
                accept="image/*"
                text="صورة هوية الوكيل الشرعي"
                icon={<UploadOutlined />}
                multiple={false}
                maxCount={1}
                onChange={(fileList) =>
                  handleFileChange(fileList, "legal_guardian_image_ids")
                }
                list={fileLists["legal_guardian_image_ids"] || []}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
      <div className="takaful--title-tabs-sub">
        <span>الحساب البنكي</span>
      </div>
      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_account_number"
            label="رقم الحساب"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs type="tel" disabled={disabled} />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_bank_id"
            label="البنك"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={banks} disabled={disabled} />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_account_owner"
            label="صاحب الحساب"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            className="takaful--label-inputs"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs type="text" disabled={disabled} />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="guardian_acc_number_iban"
            label="صورة رقم الايبان"
            labelCol={{ className: "takaful--label-style" }}
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
          >
            <UploadInput
              accept="image/*"
              text="صورة رقم الايبان"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={(fileList) =>
                handleFileChange(fileList, "guardian_acc_number_iban")
              }
              list={fileLists["guardian_acc_number_iban"] || []}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default MainProviderInfo;
